import apiClient from 'utilities/apiClient';

export const batches = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.batch}/${url}`, payload, true);
};

export const qcApprove = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.qc}/${url}`, payload, true);
};

export const dispensingList = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.dispense}/${url}`, payload, true);
};

export const updateDispensing = (url, payload) => {
  return apiClient.patch(`${apiClient.Urls.dispense}/${url}`, payload, true);
};

export const crete_testForm = (url, payload) => {
  // HTTP method is determined by the URL (matches backend route):
  //   POST  /trf/create-trf        → createTestRequestForm
  //   PATCH /trf/update-trf        → updateTestRequestForm
  //   POST  /trf/regenerate_trf    → RegenerateTrf
  // Previously this routed on payload.trf_id which broke when the slice chose
  // 'create-trf' for a batch that happened to have a trf_id (code-to-code child).
  return url === 'update-trf'
    ? apiClient.patch(`${apiClient.Urls.trf}/${url}`, payload, true)
    : apiClient.post(`${apiClient.Urls.trf}/${url}`, payload, true);
};
